import Firestore from 'src/authentication/handlers/firestore';
import { Dims } from 'config/constants';

export const appicableQuillBoxesHeightInVh = () =>
  Firestore.getInstance().premium ? Dims.quillBoxesInVhForPremium : Dims.quillBoxesInVh;

export const textBoxesMinHeight = () => `calc(${appicableQuillBoxesHeightInVh()}vh)`;

export const extSliderValues = {
  min: 2,
  max: 20,
  step: 9, // Adding step of 9 for slider so total slider steps will be equal to 10.
};
export const absSliderValues = {
  min: 1,
  max: 4,
  marks: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
};
